import { Col } from "@commonlibs";
import clsx from "clsx";
import { ReactNode } from "react";
import { TextFieldProps } from "../TextField.types";

export interface TextFieldSuffixProps {
    className?: string;
    style?: React.CSSProperties;
    suffix: ReactNode;
}

const TextFieldSuffix = ({ suffix, style, className }: TextFieldProps): JSX.Element => {
    return typeof suffix === "string" ? (
        <Col css={{ height: "100%" }} className={clsx(className, "suffix")} justifyContent="flex-end">
            <span style={style} className="suffix-txt">
                {suffix}
            </span>
        </Col>
    ) : (
        <>{suffix}</>
    );
};

export default TextFieldSuffix;
